// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"_p-z","breadcrumbForward":"aq-z","breadcrumbBack":"bq-z","selected":"cq-z"};